module.exports = __webpack_public_path__ + "static/Highlight1-9cddc82b7e06567f2dc6a71b0d8502b4.png";